/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AlertsIcon from 'icons/AlertsIcon';

const messages = defineMessages({
  title: {id: 'navigation.alerts'},
});

const AlertsItem = () => (
  <RouteLinkItem
    iconBefore={AlertsIcon}
    route="midas/students/alerts"
    title={messages.title}
  />
);

export default AlertsItem;
